import { InsuranceCardActions } from '../../actions/InsuranceCardActions';
import { AppointmentInfoPageActions } from './AppointmentInfoPageActions';

const defaultState = {
    hasTimeslotConstraint: false,
    showInsuranceError: false,
    showPayForSelfError: false,
    insuranceCoverageStatus: null,
    planIdFromCard: null,
};

export const appointmentInfoPageReducer = (state = defaultState, action) => {
    switch (action.type) {
        case AppointmentInfoPageActions.SET_TIMESLOT_CONSTRAINT: {
            return {
                ...state,
                hasTimeslotConstraint: true,
            };
        }

        case AppointmentInfoPageActions.CLEAR_TIMESLOT_CONSTRAINT: {
            return {
                ...state,
                hasTimeslotConstraint: false,
            };
        }

        case AppointmentInfoPageActions.SHOW_INSURANCE_ERROR: {
            return {
                ...state,
                showInsuranceError: true,
            };
        }
        case AppointmentInfoPageActions.SHOW_PAY_FOR_SELF_ERROR: {
            return {
                ...state,
                showPayForSelfError: true,
            };
        }

        case InsuranceCardActions.SELECTED: {
            const { isCarrierChange, isPlanChange } = action;
            if (isCarrierChange || isPlanChange) {
                return {
                    ...state,
                    showInsuranceError: false,
                    showPayForSelfError: false,
                };
            }
            return state;
        }

        default:
            return state;
    }
};
